import './migration-strategy.scss';

import { Box, Button, CollectionPreferencesProps, ColumnLayout, Grid, Modal, 
    NonCancelableCustomEvent, SpaceBetween, Toggle, ToggleProps 
} from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';
import { deepCopy } from '../../common/util';

interface Props {
    visibleColumns: string[];
    setVisibleColumns: (preference: any) => void;
    disabled?: boolean;
    visibleContentOptions?: CollectionPreferencesProps.VisibleContentPreference;
    visible: boolean;
    setVisible: (visible: boolean) => void;
}

const MigrationTablePreferences = (props: Props): JSX.Element => {
    const dismissModal = (): void => props.setVisible(false);

    const footer = (
        <Box float='right'>
            <SpaceBetween direction='horizontal' size='xs'>
                <Button variant='primary' onClick={dismissModal}>{constants.CLOSE_BUTTON_TEXT}</Button>
            </SpaceBetween>
        </Box>
    );

    const onToggleChanged = (columnId: string) => (event: NonCancelableCustomEvent<ToggleProps.ChangeDetail>) => {
        const columns = deepCopy(props.visibleColumns);
        if (event.detail.checked) {
            if (!columns.includes(columnId)) {
                columns.push(columnId);
            }     
        } else {
            if (columns.includes(columnId)) {
                columns.splice(columns.indexOf(columnId), 1);
            }
        }
        props.setVisibleColumns(columns);
    };

    const isChecked = (columnId: string): boolean => {
        return props.visibleColumns.includes(columnId);
    };

    const content = props.visibleContentOptions ? (
        props.visibleContentOptions.options.map(toplevelOption => {
            const subOptions = toplevelOption.options.map(option => {
                return (
                    <Grid gridDefinition={[{colspan: 9}, {colspan: 3}]} key={option.id} >
                        {option.label}
                        <Box float='right'>
                            <Toggle checked={isChecked(option.id)} onChange={onToggleChanged(option.id)}/>
                        </Box>
                    </Grid>
                );
            });
            return (
                <SpaceBetween size='m'>
                    <div className='preference-modal-label'>{toplevelOption.label}</div>
                    <Box margin={{right:'xxl', left: 'xxl'}}>
                        <ColumnLayout borders='horizontal' columns={1}>
                            {subOptions}
                        </ColumnLayout>
                    </Box>
                </SpaceBetween>
            );
        })) : null;

    return (
        <Modal
            visible={props.visible}
            footer={footer}
            header={constants.PREFERENCE_HEADER}
            onDismiss={dismissModal}
        >
            {content}
        </Modal>
    );
};

export default MigrationTablePreferences;
